<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ (readOnly ? 'admin.userDetails' : editMode ? 'admin.editUser' : 'admin.newUser') | translate }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>

  <div class="modal-body">

    @if (error && userForm.untouched) {
      <div class="alert alert-danger mb-3">
        @if (errorCode) {
          <div>{{ 'admin.userForm.errors.' + errorCode | translate }}</div>
        }
        @if (!errorCode) {
          <div>{{ 'admin.userForm.errors.generic'  | translate }}</div>
        }
      </div>
    }

    <form [formGroup]="userForm" [class.pe-none]="readOnly">
      <fieldset [disabled]="readOnly" class="border-0 p-0 m-0 min-w-0">
      <div class="row">
        <div class="col-12 mb-3">
          <app-multiple-organisation-selector
            [organisationsForm]="organisations"
            [organisationTree]="organisationTree!">
          </app-multiple-organisation-selector>
        </div>
      </div>

      @if (isTeamMember) {
        <div class="row">
          <div class="col-12 mb-3 d-flex align-items-center">
            <label class="form-check form-switch cursor-pointer my-0">
              <input class="form-check-input cursor-pointer"
                type="checkbox"
                formControlName="disableTeamMemberRestriction" />
              <span class="form-check-label">
                {{ 'admin.userForm.labels.disableTeamMemberRestriction' | translate }}
              </span>
            </label>
            <span class="ms-2 form-help" [ngbPopover]="'admin.userForm.disableTeamMemberRestrictionHint' | translate">?</span>
          </div>
          
        </div>
      }

      <div class="row">
        <div class="col mb-3">
          <label for="user-email" class="form-label">
            {{ 'admin.userForm.labels.emailAddress' | translate }}
          </label>
          <input id="user-email"
            formControlName="emailAddress"
            type="text"
            class="form-control"
            [class.is-invalid]="emailAddress.invalid && emailAddress.touched"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 mb-3">
            <label for="user-first-name" class="form-label">
              {{ 'admin.userForm.labels.firstName' | translate }}
            </label>
            <input id="user-first-name"
              formControlName="firstName"
              type="text"
              class="form-control"
              [class.is-invalid]="firstName.invalid && firstName.touched"
              />
            </div>

            <div class="col-12 col-md-6 mb-3">
              <label for="user-surname" class="form-label">
                {{ 'admin.userForm.labels.surname' | translate }}
              </label>
              <input id="user-surname"
                formControlName="surname"
                type="text"
                class="form-control"
                [class.is-invalid]="surname.invalid && surname.touched"
                />
              </div>
            </div>

            <div class="row">
              @if (availableApplications.length > 0) {
                <div class="col-12">
                  <app-user-app-selector [userForm]="userForm"
                    [availableApplications]="availableApplications"
                  ></app-user-app-selector>
                </div>
              }
            </div>
      </fieldset>
          </form>
        </div>

        <div class="modal-footer">
          <button id="btn-cancel-user-form"
            class="btn btn-link link-secondary"
            (click)="activeModal.dismiss()">
            {{ 'cancel' | translate }}
          </button>

          @if (!readOnly) {
            <button id="btn-submit-user-form"
              class="btn btn-primary ms-auto"
              (click)="submitForm()"
              [disabled]="userForm.invalid || submitting"
              >
              @if (!submitting) {
                <span>{{ 'submit' | translate }}</span>
              }
              @if (submitting) {
                <span class="spinner-border text-primary" role="status"></span>
              }
            </button>
          }
        </div>
      </div>
